const HIDDEN_MODEL_NAMES = new Set(['yhc_master_versions'])

const isMenuForHiddenModel = (item: any): boolean => {
  if (!item) return false
  const modelName =
    item.linkTargetModel ||
    item.modelName ||
    String(item.id || '').replace(/^model-/, '')
  return HIDDEN_MODEL_NAMES.has(String(modelName))
}

const filterMenuItemsDeep = (items: any[] | undefined | null): any[] => {
  if (!items?.length) return items || []
  return items
    .filter((item) => !isMenuForHiddenModel(item))
    .map((item) => {
      if (item?.children?.length) {
        return { ...item, children: filterMenuItemsDeep(item.children) }
      }
      return item
    })
}

/**
 * 管理画面サイドバー「モデル一覧」を tableName 昇順にする。
 * あわせて登録を yhc_masters に集約したモデルをメニューから隠す。
 * CORE の adminAppMenu フックを利用（CORE 本体は変更しない）。
 */
export function registerAdminAppMenuModelListSort() {
  $core.$appHook.on(
    'adminAppMenu',
    (menu) => {
      const filtered = filterMenuItemsDeep(menu)
      const modelsItem = filtered?.find((item) => item?.id === 'nested-models')
      if (!modelsItem) {
        console.warn(
          '[YHC] adminAppMenu: nested-models not found; model list sort skipped',
        )
        return filtered
      }
      if (modelsItem.children?.length) {
        modelsItem.children = [...modelsItem.children].sort((a, b) => {
          const aKey = String(a?.id || a?.label || '').replace(/^model-/, '')
          const bKey = String(b?.id || b?.label || '').replace(/^model-/, '')
          return aKey.localeCompare(bKey)
        })
      }
      return filtered
    },
    'yhc-sort-admin-model-list-by-tableName',
  )
}

/**
 * アプリ定義の mainMenus から yhc_master_versions を除外する。
 * DB 上の appDefinitions は書き換えず、ロード後にフィルタする。
 */
export function registerHideYhcMasterVersionsFromAppMenu() {
  $core.$appHook.on(
    '$appDefinitionLoader.appDefinitionLoaded',
    () => {
      const appDef = $core.$appDefinitionLoader?.appDefinition
      if (appDef?.mainMenus?.length) {
        appDef.mainMenus = appDef.mainMenus.filter(
          (menu) => menu?.linkTargetModel !== 'yhc_master_versions',
        )
      }
      const allByKey = $core.$appDefinitionLoader?.allAppDefinitionsByKey
      if (allByKey) {
        for (const def of Object.values(allByKey)) {
          if (def?.mainMenus?.length) {
            def.mainMenus = def.mainMenus.filter(
              (menu) => menu?.linkTargetModel !== 'yhc_master_versions',
            )
          }
        }
      }
    },
    'yhc-hide-yhc_master_versions-from-app-menu',
  )
}
